(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ae-kids-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var dialog  = document.querySelector('.ae-kids__dialog');
  var track   = dialog && dialog.querySelector('.ae-kids__img-track');
  var dotsEl  = dialog && dialog.querySelector('.ae-kids__dots');
  var prevBtn = dialog && dialog.querySelector('.ae-kids__arr--prev');
  var nextBtn = dialog && dialog.querySelector('.ae-kids__arr--next');
  var nameEl  = dialog && dialog.querySelector('.ae-kids__dialog-name');
  var priceEl = dialog && dialog.querySelector('.ae-kids__dialog-price');
  var pillsEl = dialog && dialog.querySelector('.ae-kids__pills');
  var perPair = dialog && dialog.querySelector('.ae-kids__per-pair');
  var minus   = dialog && dialog.querySelector('.ae-kids__minus');
  var plus    = dialog && dialog.querySelector('.ae-kids__plus');
  var qtyEl   = dialog && dialog.querySelector('.ae-kids__qty');
  var atcBtn  = dialog && dialog.querySelector('.ae-kids__atc');
  var atcPrc  = dialog && dialog.querySelector('.ae-kids__atc-price');
  var fullLnk = dialog && dialog.querySelector('.ae-kids__full-link');
  var closeBtn= dialog && dialog.querySelector('.ae-kids__close');
  if (!dialog || !track) return;

  // ── State ──────────────────────────────────────────────
  var s = { vid: 0, qty: 1, packs: 1, cents: 0, rate: 0 };
  var imgCount = 0;

  function fmt(cents) { return '€' + (cents / 100).toFixed(2); }

  function render() {
    var total   = s.cents * s.packs;
    var pairs   = s.qty * s.packs;
    qtyEl.textContent    = s.packs;
    atcPrc.textContent   = fmt(total);
    priceEl.textContent  = fmt(total);
    minus.disabled       = (s.packs <= 1);
    perPair.textContent  = pairs + (pairs === 1 ? ' pair' : ' pairs') + ' · ' + fmt(s.rate) + '/pair';
  }

  // ── Image slider ───────────────────────────────────────
  function syncDots() {
    var idx = Math.round(track.scrollLeft / Math.max(track.offsetWidth, 1));
    dotsEl.querySelectorAll('.ae-kids__dot').forEach(function (d, i) {
      d.classList.toggle('ae-kids__dot--on', i === idx);
    });
    if (prevBtn) prevBtn.hidden = (idx === 0);
    if (nextBtn) nextBtn.hidden = (idx >= imgCount - 1);
  }

  track.addEventListener('scroll', syncDots, { passive: true });

  if (prevBtn) prevBtn.addEventListener('click', function () {
    track.scrollBy({ left: -track.offsetWidth, behavior: 'smooth' });
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    track.scrollBy({ left:  track.offsetWidth, behavior: 'smooth' });
  });

  // ── Open dialog ────────────────────────────────────────
  function openDialog(data) {
    var images = data.images || [];
    var packs  = data.packs  || [];
    imgCount   = images.length;

    // Build image slides
    track.innerHTML  = '';
    dotsEl.innerHTML = '';
    images.forEach(function (url, i) {
      var slide = document.createElement('div');
      slide.className = 'ae-kids__img-slide';
      var img = document.createElement('img');
      img.src = url; img.alt = data.title; img.loading = 'lazy';
      slide.appendChild(img);
      track.appendChild(slide);

      var dot = document.createElement('span');
      dot.className = 'ae-kids__dot' + (i === 0 ? ' ae-kids__dot--on' : '');
      dotsEl.appendChild(dot);
    });
    track.scrollLeft = 0;
    dotsEl.hidden    = (imgCount <= 1);
    if (prevBtn) prevBtn.hidden = true;
    if (nextBtn) nextBtn.hidden = (imgCount <= 1);

    // Pack pills
    pillsEl.innerHTML = '';
    packs.forEach(function (pack, i) {
      var btn = document.createElement('button');
      btn.className   = 'ae-kids__pill' + (i === 0 ? ' ae-kids__pill--on' : '');
      btn.textContent = pack.label;
      btn.addEventListener('click', function () {
        pillsEl.querySelectorAll('.ae-kids__pill').forEach(function (p) {
          p.classList.remove('ae-kids__pill--on');
        });
        btn.classList.add('ae-kids__pill--on');
        s.vid = pack.vid; s.qty = pack.qty;
        s.cents = pack.price; s.rate = pack.rate;
        s.packs = 1;
        render();
      });
      pillsEl.appendChild(btn);
    });

    // Initial state
    var fp = packs[0] || {};
    s.vid = fp.vid; s.qty = fp.qty || 1;
    s.cents = fp.price || 0; s.rate = fp.rate || 0;
    s.packs = 1;
    nameEl.textContent = data.title;
    fullLnk.href = data.url;
    render();

    dialog.showModal();
  }

  // ── Close dialog ───────────────────────────────────────
  function closeDialog() {
    // animate out, then close
    dialog.style.opacity    = '0';
    dialog.style.transform  = window.matchMedia('(max-width: 719px)').matches
      ? 'translateY(24px)'
      : 'scale(.96) translateY(8px)';
    setTimeout(function () {
      dialog.close();
      dialog.style.opacity   = '';
      dialog.style.transform = '';
    }, 270);
  }

  closeBtn.addEventListener('click', closeDialog);

  // Click on the <dialog> backdrop area
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeDialog();
  });

  // Native cancel (Escape key)
  dialog.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeDialog();
  });

  // ── Stepper ────────────────────────────────────────────
  minus.addEventListener('click', function () { if (s.packs > 1) { s.packs--; render(); } });
  plus.addEventListener('click',  function () { s.packs++; render(); });

  // ── Add to Cart ────────────────────────────────────────
  atcBtn.addEventListener('click', function () {
    atcBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: s.vid, quantity: s.packs })
    })
    .then(function (r) { return r.json(); })
    .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
    .then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: cart.item_count } }
      }));
      closeDialog();
    })
    .catch(function (err) { console.error('[ae-kids] cart error', err); })
    .finally(function () { atcBtn.disabled = false; });
  });

  // ── Card clicks ────────────────────────────────────────
  document.querySelectorAll('.ae-kids__card').forEach(function (card) {
    card.addEventListener('click', function () {
      var el = card.querySelector('.ae-kids__data');
      if (!el) return;
      try { openDialog(JSON.parse(el.textContent)); }
      catch (e) { console.error('[ae-kids]', e); }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
